import React, {FC} from 'react';

import {makeContactCardPanelId} from '../../../libs/shared/core/src/store/panels/panelStateBase';
import {PopoverTransferProps} from '../../../libs/shared/ui/src/components/popovers/popoverCoordinator';
import {VisualContactModel} from '../../models/api/visualContactModel';
import {ContactCardParentPanelId} from '../../store/panels/contacts/contactCard/contactCardPanelActions';
import {ContactCardLocationsEnum} from '../../store/panels/contacts/contactCard/contactCardPanelState';
import {TransientContactCardContainer} from './contactCardContainer';

/*
 * Props.
 */

interface ContactCardContainerProps {
  panelId: ContactCardParentPanelId;
  visualContact: VisualContactModel;
  popoverProps: PopoverTransferProps;
  location: ContactCardLocationsEnum;
  isUnverified?: boolean;
}

/*
 * Component.
 */

export const ContactCardWrapperContainer: FC<ContactCardContainerProps> = (props) => {
  const {panelId, visualContact, popoverProps, location, isUnverified} = props;
  return (
    <TransientContactCardContainer
      parentPanelId={panelId}
      panelId={makeContactCardPanelId(panelId)}
      visualContact={visualContact}
      popoverProps={popoverProps}
      location={location}
      isUnverified={isUnverified}
    />
  );
};
